import React, { useState } from 'react';
import {
  Box,
  ButtonBase,
  Checkbox,
  Dialog,
  FormControlLabel,
  IconButton,
  InputBase,
  Typography,
} from '@material-ui/core';
import * as Yup from 'yup';
import { CloseIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import { baseSetting } from '../baseCss';

export default function BasePop({
  closePop,
  open,
  title,
  subTitle,
  active,
  showActive,
  firstBtnText,
  secondBtnText,
  firstBtnClick,
  secondBtnClick,
  inputName,
}) {
  const baseClasses = baseSetting();
  const [errorMsg, setErrorMsg] = useState();

  const [isActive, setIsActive] = useState(active ?? 1);
  const activeChange = (event) => {
    event.target.checked ? setIsActive(1) : setIsActive(0);
  };

  const [name, setName] = useState(inputName ?? '');
  const nameHandleChange = (event) => {
    setName(event.target.value);
  };

  const schema = {
    [i18n.t('BEDSTATUS_SETTING_REMARK')]: Yup.string()
      .max(40, i18n.t('BEDSTATUS_REMARK_LENGTH'))
      .required(i18n.t('BEDSTATUS_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_SETTING_REMARK') })),
  };

  const checkSubmitData = async (schema, data) => {
    try {
      await schema.validate(data, {
        abortEarly: false,
      });
    } catch (err) {
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          if (error.path !== undefined) {
            validationErrors[error.path] = error.message;
          }
        });
      }
      throw validationErrors;
    }
  };

  const focusCheck = (value, data) => {
    return async () => {
      try {
        await checkSubmitData(Yup.object().shape({ [value]: schema[value] }), {
          [value]: data,
        });
        setErrorMsg({ ...errorMsg, [value]: null });
      } catch (e) {
        setErrorMsg({ ...errorMsg, ...e });
      }
    };
  };

  const submitCheck = async (value, data) => {
    try {
      await checkSubmitData(Yup.object().shape({ [value]: schema[value] }), {
        [value]: data,
      });
      setErrorMsg({ ...errorMsg, [value]: null });
      return false;
    } catch (e) {
      setErrorMsg({ ...errorMsg, ...e });
      return true;
    }
  };

  return (
    <Dialog open={open} maxWidth={false}>
      <div className={baseClasses.root}>
        <div className={baseClasses.header} style={{ padding: '2.375rem 0 1.563rem' }}>
          <Typography className={baseClasses.headerTitle}>{title}</Typography>
          <IconButton
            id="bed_setting_close_btn"
            className={baseClasses.closeIcon}
            onClick={closePop}
            style={{ marginRight: '-12px' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <Typography className={baseClasses.labelText} style={{ marginBottom: '0.625rem' }}>
          {subTitle}
        </Typography>
        <InputBase
          id="bed_setting_pop_input"
          className={baseClasses.inputText}
          placeholder={subTitle}
          value={name}
          onChange={nameHandleChange}
          onBlur={() => {
            (async () => {
              await focusCheck(i18n.t('BEDSTATUS_SETTING_REMARK'), name)();
            })();
          }}
          style={errorMsg && errorMsg[i18n.t('BEDSTATUS_SETTING_REMARK')] ? { borderColor: '#f44336' } : {}}
        />
        {errorMsg && errorMsg[i18n.t('BEDSTATUS_SETTING_REMARK')] && (
          <Typography
            style={{
              margin: '3px 0.825rem 0 0.825rem',
              color: '#f44336',
              fontFamily: 'NotoSans-Medium',
              fontWeight: '500',
            }}
          >
            {errorMsg[i18n.t('BEDSTATUS_SETTING_REMARK')]}
          </Typography>
        )}
        {showActive ? (
          <FormControlLabel
            id="bed_setting_pop_check"
            control={<Checkbox />}
            label={i18n.t('BEDSTATUS_ACTIVE')}
            className={baseClasses.checkBox}
            checked={Boolean(isActive)}
            onChange={activeChange}
            style={{ marginTop: '1.313rem' }}
          />
        ) : (
          ''
        )}
        <Box display="flex" justifyContent="center" style={{ margin: '3.125rem 0 1.875rem 0' }}>
          <ButtonBase
            id="bed_setting_pop_cancel"
            className={baseClasses.cancelBtn}
            style={{ marginRight: '1.313rem' }}
            onClick={() => {
              if (typeof firstBtnClick === 'function') {
                firstBtnClick({ isActive: isActive, name: name });
              }
              closePop();
            }}
          >
            {firstBtnText}
          </ButtonBase>
          <ButtonBase
            id="bed_setting_pop_confirm"
            className={baseClasses.configBtn}
            style={{ opacity: name.length === 0 ? 0.2 : 1 }}
            onClick={() => {
              (async () => {
                if (await submitCheck(i18n.t('BEDSTATUS_SETTING_REMARK'), name)) {
                  return;
                }
                if (typeof secondBtnClick === 'function') {
                  secondBtnClick({ isActive: isActive, name: name, errorMsg: errorMsg });
                }
                closePop();
              })();
            }}
          >
            {secondBtnText}
          </ButtonBase>
        </Box>
      </div>
    </Dialog>
  );
}
